import { useState } from "react";
import { GeneralModal } from "../../../../components/GeneralModal/GeneralModal";
import {
  useCreateCategoryMutation,
  useCreateSubCategoryMutation,
  useUpdateCategoryMutation,
  useUpdateSubCategoryMutation,
} from "../../../../../../store/apiSlice/fileApiSlice";
import { InputText, ShowError } from "../../../../components/InputText/InputText";

export const CreateFileCategory = ({
  closeCreateFileCategory,
  fileCategoryName,
  isOpenCategoryModal,
  categoryId,
  getSubCategory,
}) => {
  const [updateFileCategory] = useUpdateCategoryMutation();
  const [addCategory] = useCreateCategoryMutation();
  const [updateFileSubCategory] = useUpdateSubCategoryMutation();
  const [addSubCategory] = useCreateSubCategoryMutation();

  const [fileCategoryData, setfileCategoryData] = useState(fileCategoryName);

  const handleInputChange = e => {
    if (e.target.name) {
      setfileCategoryData(state => ({ ...state, [e.target.name]: e.target.value }));
    }
  };

  const handleCreateMilestone = async () => {
    if (isOpenCategoryModal === "category") {
      if (fileCategoryData.id) {
        await updateFileCategory({ id: fileCategoryData.id, data: { ...fileCategoryData } });
        closeCreateFileCategory();
        return;
      }
      addCategory(fileCategoryData);
    } else if (isOpenCategoryModal === "subCategory") {
      if (fileCategoryData.id) {
        await updateFileSubCategory({ id: fileCategoryData.id, data: { ...fileCategoryData } });
        getSubCategory(new URLSearchParams({ document_category_id: categoryId }).toString());
        closeCreateFileCategory();
        return;
      }

      await addSubCategory({ document_category_id: categoryId, name: fileCategoryData.name });
      getSubCategory(new URLSearchParams({ document_category_id: categoryId }).toString());
    }
    closeCreateFileCategory();
  };

  const name = fileCategoryData.name || "";
  const canSave = name.trim().length > 0 && name.length <= 50;

  return (
    <GeneralModal
      titleOfModal={`${fileCategoryData.id ? "Edit" : "Create"} ${isOpenCategoryModal === "category" ? "Category" : "Sub Category"}`}
      isCancelButttonShow={true}
      handleModalWork={handleCreateMilestone}
      closeModal={closeCreateFileCategory}
      btnName={fileCategoryData.id ? "Save" : "Create"}
      isChecked={canSave}
      widthOfGeneralModal="420px"
      classNameOfModal="fileCategoryModal"
    >
      <InputText
        labelOfInput="Name"
        placeholder={
          isOpenCategoryModal === "category" ? "Category name" : "Subcategory name"
        }
        setText={handleInputChange}
        text={name}
        heightOfInput="36px"
        widthOfInput="100%"
        inputName="name"
      />

      {name.length > 50 && <ShowError errorText="Limit reached: Maximum 50 characters allowed" />}
    </GeneralModal>
  );
};
